export default __webpack_public_path__ + "static/media/296.8a4264ad.jpg";